// 9fbef606107a605d69c0edbcd8029e5d
import constants from '../MailingAddress.constants';

export const addMailingAddressSuccess = (payload) => {
  return {
    type: constants.ADD_MAILING_ADDRESS_SUCCESS,
    payload,
  };
};
export const addMailingAddressFail = (payload) => {
  return {
    type: constants.MAILING_ADDRESS_ERR,
    payload,
  };
};

export const addMailingAddress = (payload) => {
  return {
    type: constants.ADD_MAILING_ADDRESS,
    payload,
  };
};

export const clearMailingAddress = () => {
  return {
    type: constants.CLEAR_MAILING_ADDRESS_STATE,
  };
};
